export default function(instance){
    return{
        Commit(payload){
            return instance.put("/CompanyUserCompanyBrandPlan/Commit", payload);
        },
    }
}
